import { notifySuccess, useNotifications } from 'Logic/Notifications.js'

export function useOnClick(props) {
  let [, notify] = useNotifications()

  return async function onClick(e) {
    e.stopPropagation()
    // eslint-disable-next-line compat/compat
    await navigator.clipboard.writeText(props.value)
    notify(notifySuccess('Copied to clipboard'))
  }
}
